import PageTitleComponent from "../../components/PageTitle";
import ProductDetailPage from "../../components/Products/view";

export default function ProductDetailsScreen(){
return <div>
    <PageTitleComponent title="Product Details" />
    <ProductDetailPage/>
</div>
}